/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';

const TooltipIcon = ({ tipId, onClick, imgSrc, displayData, placement, customClass, customStyle }) => {
  const [portActivityOpen, setPortActivityOpen] = useState(false);

  const toggle = () => setPortActivityOpen(!portActivityOpen);

  return (
    <>
      <span id={tipId} className={customClass ? customClass : 'analytics-icon'} onClick={onClick}>
        <img src={imgSrc} style= {customStyle ? customStyle : { width: '30px' }} />
      </span>
      <Tooltip
        delay={0}
        placement={placement}
        isOpen={portActivityOpen}
        target={tipId}
        toggle={toggle}
      >
        {displayData}
      </Tooltip>
    </>
  );
};

export default TooltipIcon;
